<template>
  <div>
    <v-row v-if="complaint.clarificationRequestList && complaint.clarificationRequestList.length >0">
      <v-col
        v-for="(item , index) in complaint.clarificationRequestList"
        :key="index"
        cols="4"
      >
        <v-card
          class="custom-naj-card"
          @click="viewRequest(item)"
        >
          <v-row class="mt-0">
            <v-col class="pa-0">
              <span
                class="status"
                :class="item.viewMode ?'status-approved' : 'status-inprogress'"
              >{{ item.viewMode ? local.complaints.complaintDetails.clarificationRequestInfo.completed
                : local.complaints.complaintDetails.clarificationRequestInfo.inprogress }}</span>
              <h4>
                <v-icon>
                  mdi-cog
                </v-icon>
                {{ item.requestType }}
              </h4>
            </v-col>
          </v-row>
          <v-row class="mt-0">
            <v-col class="ps-0">
              <div>
                <label class="d-block">{{ local.complaints.complaintDetails.requestLogInfo.requestNumber }}</label>
                <span class="mb-0 font-weight-bold">
                  {{ item.requestNo ? item.requestNo : '__' }}
                </span>
              </div>
            </v-col>
            <v-col>
              <div>
                <label class="d-block"> {{ local.complaints.complaintDetails.requestLogInfo.requestDate }}</label>
                <span class="mb-0 font-weight-bold">
                  {{ item.createdDateH ? item.createdDateH : '__' }}
                </span>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <view-inspector-request-modal
      :request="selectedRequest"
      :view-mode="selectedRequest.viewMode"
      :modal-visibility="showViewRequestModal"
      @onClose="showViewRequestModal = false"
      @updateComplaint="updateComplaint"
    >
    </view-inspector-request-modal>
  </div>
</template>

<script>
import ViewInspectorRequestModal from './viewInspectorRequestModal.vue';
import { requestStatusIds } from '@/modules/complaints/helpers/enum';
export default {
  name: 'InspectorRequestList',
  components: { ViewInspectorRequestModal },
  props: {
    complaint: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selectedRequest: {},
      showViewRequestModal: false,
    };
  },
  computed: {},
  watch: {},
  created() {
  },
  mounted() {
  },
  methods: {
    statusColor(item) {
      var cls = 'status-';
      if (item.statusID == requestStatusIds.inprogress)
        return cls + 'inprogress';
      else if (item.statusID == requestStatusIds.approved)
        return cls + 'approved';
      else
        return cls + 'rejected';
    },
    viewRequest(item) {
      this.selectedRequest = item;
      this.showViewRequestModal = true;
    },
    updateComplaint() {
      this.complaint.updateComplaint = true;
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep {
  .custom-naj-card.v-card {
    border: 1px solid #dee2e6;
    border-right: 2px solid #b69a70;
    border-left: 2px solid #b69a70;
    border-radius: 0;
    padding: 24px;
    -webkit-box-sizing: content-box;
    box-sizing: content-box;
    box-shadow: none !important;
    p,
    label {
      color: #34675a;
    }
    h4 {
      color: #343a40;
      font-size: 18px;
      margin: 0 0 24px 0;
      .v-icon {
        font-size: 18px;
        color: #343a40;
      }
    }

    .status {
      border-radius: 20px;
      color: white;
      font-size: 12px;
      font-weight: bold;
      float: inline-end;
      padding: 4px 8px;
      &.status-inprogress {
        background-color: #6f5d2f;
      }
      &.status-approved {
        background-color: green;
      }
      &.status-rejected {
        background-color: red;
      }
    }
  }
}
</style>
